/**
 * The D-5 link rule between hubs (master D-5, web plan W3.1), dependency-free
 * so the footer (entry chunk) can apply it without pulling in the hub page's
 * helpers (@/seo/categoryHubs, which re-exports these).
 */
import type { EntitySeo } from '@/types';

/** A site path, or null (never an absolute or protocol-relative URL: `//host`, `/\host`). */
export function sitePath(path: string | null | undefined): string | null {
  const value = path?.trim();
  return value && /^\/(?![/\\])/.test(value) ? value : null;
}

/**
 * Whether a hub may link to another hub (a brand hub, a parent or
 * sub-category hub, the footer's "Top categories"): only while the backend
 * lists it (`seo.indexable`). Below its threshold (HUB_BELOW_THRESHOLD) or not
 * listed yet (HUB_NOT_LISTED_YET) it is not linked from other hubs.
 */
export function linkedFromHubs(entity: { seo?: EntitySeo | null } | null | undefined): boolean {
  return entity?.seo?.indexable === true;
}
